module.exports = __webpack_public_path__ + "static/media/ic-recommendation1.1-ex.4413fafc.png";